import store from '@/store'
import audienceApi from '@/api/audience'
import Util from '@/util'

const updateAudienceData = async () => {
  const payload = {
    audienceId: store.state.audienceId,
    presentationId: store.state.presentation.id,
  }
  if (store.state.audienceEmail) {
    payload.email = store.state.audienceEmail
  }
  if (store.state.audienceName) {
    payload.name = store.state.audienceName
  }
  if (store.state.audienceTeam) {
    payload.organisation = store.state.audienceTeam
  }

  try {
    await audienceApi.createAudience(payload)
    Util.gaTrackEvent(
      'Audience',
      'Audience > Audience Admission > Joined',
    )
  } catch (error) {
    Util.gaTrackEvent(
      'Audience',
      'Audience > Audience Admission > Failed',
      JSON.stringify(error),
    )
  }
}
export default {
  updateAudienceData,
}
